// import { useState, useEffect } from "react";
// import { useAuth } from "../Context/AuthContext";
// import ErrorMessage from "../Helpers/ErrorMessage";
// import API from "../Context/api";
// import Spinner from "../Helpers/Spinner";

// const EditComputerForm = ({ setIsModalOpen, onComputerAdded, id }) => {
//   const { user } = useAuth();
//   const createdBy = user ? user.name : "";
//   const [isFetching, setIsFetching] = useState(false); // For fetching data
//   const [isLoading, setIsLoading] = useState(false); // For form submission
//   const [errorMessage, setErrorMessage] = useState("");
//   const [technicians, setTechnicians] = useState([]);
//   const [originalData, setOriginalData] = useState(null);

//   const [formData, setFormData] = useState({
//     id: "",
//     computerId: "",
//     name: "",
//     serialNumber: "",
//     make: "",
//     model: "",
//     client: "",
//     companyAssetTag: "",
//     inventoryTrackingNumber: "",
//     taskId: "",
//     isFaulty: false,
//     isRepaired: false,
//     createdBy: createdBy,
//     status: "",
//     changeHistory: [],
//     repairHistory: [],
//     repairDetails: {
//       title: "",
//       computerId: "",
//       resourceAssigned: "",
//       status: "",
//       recommendations: "",
//     },
//     resourceassigned: "", // Top-level field
//   });

//   const computerMakes = [
//     "Dell",
//     "HP",
//     "Lenovo",
//     "Asus",
//     "Acer",
//     "Apple",
//     "MSI",
//   ];

//   // 🔄 Fetch technicians and original computer data
//   useEffect(() => {
//     const fetchData = async () => {
//       setIsFetching(true);
//       try {
//         const techniciansResponse = await API.get("/users/role");
//         setTechnicians(techniciansResponse.data);

//         const computerResponse = await API.get(`/computers/${id}`);
//         const data = computerResponse.data;

//         console.log(data);

//         const assignedResource = data.repairDetails.resourceassigned;

//         const formValues = {
//           id: data.id || "",
//           computerId: data.computerId || "",
//           name: data.name || "",
//           serialNumber: data.serialNumber || "",
//           make: data.make || "",
//           model: data.model || "",
//           client: data.client || "",
//           companyAssetTag: data.companyAssetTag || "",
//           taskId: data.taskId || "",
//           inventoryTrackingNumber: data.inventoryTrackingNumber || "",
//           isFaulty: data.isFaulty || false,
//           isRepaired: data.isRepaired || false,
//           createdBy: data.createdBy || createdBy,
//           status: data.status || "",
//           changeHistory: data.changeHistory || [],
//           repairHistory: data.repairHistory || [],
//           repairDetails: {
//             title:
//               data.repairDetails?.title ||
//               `${data.name} - Repair ${data.inventoryTrackingNumber}`,
//             computerId: data.repairDetails?.computerId || data.computerId || "",
//             resourceAssigned: assignedResource,
//             status: data.repairDetails?.status || "in_progress",
//             recommendations: data.repairDetails?.recommendations || "",
//           },
//           resourceassigned: assignedResource,
//         };

//         setFormData(formValues);
//         setOriginalData(formValues); // 🔥 Save original for change tracking
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setErrorMessage("Failed to load computer data or technicians");
//       } finally {
//         setIsFetching(false);
//       }
//     };

//     fetchData();
//   }, [id, createdBy]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setFormData((prev) => {
//       const newData = {
//         ...prev,
//         [name]: type === "checkbox" ? checked : value,
//       };

//       if (name === "resourceassigned") {
//         newData.repairDetails = {
//           ...prev.repairDetails,
//           resourceAssigned: value,
//         };
//       }

//       return newData;
//     });
//   };

//   const getTechnicianIdByName = (name) => {
//     const tech = technicians.find((t) => t.name === name);
//     return tech ? tech.userId : null;
//   };

//   const handleSubmit = async (e) => {
//     // e.preventDefault();

//     // ✅ Track changed fields
//     let updatedChangeHistory = [...formData.changeHistory];

//     const originalTech = originalData?.resourceassigned || "";
//     const currentTech = formData.resourceassigned;

//     const originalTechId = getTechnicianIdByName(originalTech);
//     const currentTechId = getTechnicianIdByName(currentTech);

//     if (originalData) {
//       const fieldsToTrack = [
//         "name",
//         "serialNumber",
//         "make",
//         "model",
//         "client",
//         "companyAssetTag",
//         "inventoryTrackingNumber",
//         "isFaulty",
//         "isRepaired",
//         "status",
//         "resourceassigned",
//       ];

//       fieldsToTrack.forEach((field) => {
//         const oldValue = originalData[field] ?? "";
//         const newValue = formData[field] ?? "";

//         if (String(oldValue) !== String(newValue)) {
//           updatedChangeHistory.push({
//             title: `${field} updated`, // Title for the change (You can customize this)
//             date: new Date().toISOString(), // The current timestamp for the change
//             changehistoryid: `${field}-${new Date().getTime()}`, // Unique ID for the change history entry
//             computerid: formData.computerId, // Computer ID from context
//             changedby: createdBy || "", // The person who made the change
//             field: field || "", // The field being updated
//             oldvalue: String(oldValue || ""), // Old value of the field (ensure string type)
//             newvalue: String(newValue || ""), // New value of the field (ensure string type)
//           });
//         }
//       });
//     }

//     const submissionData = {
//       ...formData,
//       changeHistory: updatedChangeHistory,
//       repairDetails: {
//         ...formData.repairDetails,
//         title: `${formData.name} - Repair ${formData.inventoryTrackingNumber}`,
//         computerId: formData.computerId,
//         resourceAssigned: formData.resourceassigned,
//       },
//     };

//     console.log("✅ Submission Data:", submissionData);

//     try {
//       setIsLoading(true);

//       const taskId = submissionData.taskId;

//       // // 🔥 Delete specific task assigned to the old tech
//       // await API.delete(`/users/tasks/${originalTechId}/${taskId}`);

//       // // ➕ Create task for the new tech
//       // await API.post("/users/tasks", {
//       //   userId: currentTechId,
//       //   title: submissionData.repairDetails.title,
//       //   description: `Repair task for ${formData.name}`,
//       //   status: "open",
//       // });

//       console.log(originalTechId);
//       console.log(currentTechId);
//       console.log(taskId);

//       // // 🔥 Delete specific task assigned to the old tech
//       // await API.delete(`/users/tasks/${originalTechId}/${taskId}`);

//       // // ➕ Create task for the new tech
//       // await API.post("/users/tasks", {
//       //   userId: currentTechId,
//       //   title: submissionData.repairDetails.title,
//       //   description: `Repair task for ${formData.name}`,
//       //   status: submissionData.repairDetails.status,
//       // });

//       // 🛠️ Handle technician change (delete + create task)
//       if (
//         originalTechId &&
//         currentTechId &&
//         originalTechId !== currentTechId &&
//         submissionData.taskId
//       ) {
//         const taskId = submissionData.taskId;

//         // 🔥 Delete specific task assigned to the old tech
//         await API.delete(`/users/tasks/${originalTechId}/${taskId}`);

//         // ➕ Create task for the new tech
//         await API.post("/users/tasks", {
//           userId: currentTechId,
//           title: submissionData.repairDetails.title,
//           description: `Repair task for ${formData.name}`,
//           status: submissionData.repairDetails.status,
//         });
//       }

//       // 💾 Update the computer
//       await API.put(`/computers/${id}`, submissionData);

//       setIsModalOpen(false);
//       if (onComputerAdded) onComputerAdded();
//     } catch (error) {
//       const errorMsg =
//         error.response?.data?.message || "Failed to update computer";
//       setErrorMessage(errorMsg);
//       console.error(error);
//     } finally {
//       setIsLoading(false);
//     }

//     // 🔒 Uncomment below to actually submit
//     // setIsLoading(true);
//     // try {
//     //   await API.put(`/computers/${id}`, submissionData);
//     //   setIsModalOpen(false);
//     //   if (onComputerAdded) onComputerAdded();
//     // } catch (error) {
//     //   const errorMsg = error.response?.data?.message || "Failed to update computer";
//     //   setErrorMessage(errorMsg);
//     // } finally {
//     //   setIsLoading(false);
//     // }
//   };

//   // 💻 Form JSX remains unchanged (already solid)
//   return (
//     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
//     //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
//     //     <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
//     //       <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
//     //         Edit Asset
//     //       </h2>

//     //       {isLoading ? (
//     //         <p>Loading computer data...</p>
//     //       ) : (
//     //         <form onSubmit={handleSubmit} className="space-y-6">
//     //           <ErrorMessage message={errorMessage} />

//     //           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//     //             <div>
//     //               <label className="block text-sm font-medium text-gray-700 mb-1">
//     //                 Asset Name *
//     //               </label>
//     //               <input
//     //                 type="text"
//     //                 name="name"
//     //                 value={formData.name}
//     //                 onChange={handleChange}
//     //                 className="w-full p-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     //                 required
//     //               />
//     //             </div>
//     //             <div>
//     //               <label className="block text-sm font-medium text-gray-700 mb-1">
//     //                 Serial Number
//     //               </label>
//     //               <input
//     //                 type="text"
//     //                 name="serialNumber"
//     //                 value={formData.serialNumber}
//     //                 onChange={handleChange}
//     //                 className="w-full p-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     //               />
//     //             </div>
//     //             <div>
//     //               <label className="block text-sm font-medium text-gray-700 mb-1">
//     //                 Model
//     //               </label>
//     //               <input
//     //                 type="text"
//     //                 name="model"
//     //                 value={formData.model}
//     //                 onChange={handleChange}
//     //                 className="w-full p-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     //               />
//     //             </div>
//     //           </div>

//     //           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//     //             <div>
//     //               <label className="block text-sm font-medium text-gray-700 mb-1">
//     //                 Make
//     //               </label>
//     //               <select
//     //                 name="make"
//     //                 value={formData.make}
//     //                 onChange={handleChange}
//     //                 className="w-full p-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     //               >
//     //                 <option value="">Select Make</option>
//     //                 {computerMakes.map((brand) => (
//     //                   <option key={brand} value={brand}>
//     //                     {brand}
//     //                   </option>
//     //                 ))}
//     //               </select>
//     //             </div>
//     //           </div>

//     //           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//     //             <div>
//     //               <label className="block text-sm font-medium text-gray-700 mb-1">
//     //                 Client *
//     //               </label>
//     //               <input
//     //                 type="text"
//     //                 name="client"
//     //                 value={formData.client}
//     //                 onChange={handleChange}
//     //                 className="w-full p-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     //                 required
//     //               />
//     //             </div>
//     //             <div>
//     //               <label className="block text-sm font-medium text-gray-700 mb-1">
//     //                 Assigned Resource
//     //               </label>
//     //               <select
//     //                 name="resourceassigned"
//     //                 value={formData.resourceassigned}
//     //                 onChange={handleChange}
//     //                 className="w-full p-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     //               >
//     //                 <option value="">Select Technician</option>
//     //                 {technicians.map((technician) => (
//     //                   <option key={technician.id} value={technician.name}>
//     //                     {technician.name}
//     //                   </option>
//     //                 ))}
//     //               </select>
//     //             </div>
//     //           </div>

//     //           <div>
//     //             <label className="block text-sm font-medium text-gray-700 mb-1">
//     //               Company Asset Tag
//     //             </label>
//     //             <input
//     //               type="text"
//     //               name="companyAssetTag"
//     //               value={formData.companyAssetTag}
//     //               onChange={handleChange}
//     //               className="w-full p-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     //             />
//     //           </div>

//     //           <div className="flex flex-col sm:flex-row gap-3 pt-4">
//     //             <button
//     //               type="submit"
//     //               disabled={isLoading}
//     //               className="w-full sm:w-auto px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:bg-blue-400"
//     //             >
//     //               {isLoading ? "Updating..." : "Update"}
//     //             </button>
//     //             <button
//     //               type="button"
//     //               onClick={() => setIsModalOpen(false)}
//     //               className="w-full sm:w-auto px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors"
//     //             >
//     //               Cancel
//     //             </button>
//     //           </div>
//     //         </form>
//     //       )}
//     //     </div>
//     //   </div>
//     // </div>
//     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
//     //   <div className="w-full max-h-[80vh] p-4 max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
//     //     <div className="h-full flex flex-col">
//     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
//       <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg">
//         <div className="flex flex-col h-[80vh] p-4">
//           {isFetching && (
//             <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
//               <Spinner />
//             </div>
//           )}
//           {/* Static Header */}
//           <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
//             Edit Asset
//           </h2>
//           <ErrorMessage message={errorMessage} />

//           {/* Scrollable Content */}
//           <div className="flex-1 overflow-y-auto space-y-3">
//             <form>
//               <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
//                 <div>
//                   <label
//                     htmlFor="name"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Asset Name
//                   </label>
//                   <input
//                     id="name"
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label
//                     htmlFor="serialNumber"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Serial Number
//                   </label>
//                   <input
//                     id="serialNumber"
//                     type="text"
//                     name="serialNumber"
//                     value={formData.serialNumber}
//                     onChange={handleChange}
//                     className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                   />
//                 </div>
//                 <div>
//                   <label
//                     htmlFor="model"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Model
//                   </label>
//                   <input
//                     id="model"
//                     type="text"
//                     name="model"
//                     value={formData.model}
//                     onChange={handleChange}
//                     className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                   />
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
//                 <div>
//                   <label
//                     htmlFor="make"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Make
//                   </label>
//                   <select
//                     id="make"
//                     name="make"
//                     value={formData.make}
//                     onChange={handleChange}
//                     className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                   >
//                     <option value="">Select Make</option>
//                     {computerMakes.map((brand) => (
//                       <option key={brand} value={brand}>
//                         {brand}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label
//                     htmlFor="client"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Client
//                   </label>
//                   <input
//                     id="client"
//                     type="text"
//                     name="client"
//                     value={formData.client}
//                     onChange={handleChange}
//                     className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label
//                     htmlFor="resourceAssigned"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Assigned Resource
//                   </label>
//                   <select
//                     id="resourceAssigned"
//                     name="resourceAssigned"
//                     value={formData.resourceAssigned}
//                     onChange={handleChange}
//                     className="block w-full max-w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm"
//                   >
//                     <option value="">Select Technician</option>
//                     {technicians.map((technician) => (
//                       <option key={technician.id} value={technician.name}>
//                         {technician.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               {/* Company Asset Tag */}
//               <div>
//                 <label
//                   htmlFor="companyAssetTag"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   Company Asset Tag
//                 </label>
//                 <input
//                   id="companyAssetTag"
//                   type="text"
//                   name="companyAssetTag"
//                   value={formData.companyAssetTag}
//                   onChange={handleChange}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                 />
//               </div>
//             </form>
//           </div>

//           {/* Action buttons */}
//           <div className="flex justify-end gap-3 mt-2">
//             <button
//               type="button"
//               onClick={() => setIsModalOpen(false)}
//               className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               onClick={() => handleSubmit()}
//               disabled={isLoading}
//               className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
//                 isLoading
//                   ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                   : "bg-blue-500 text-white hover:bg-blue-600"
//               }`}
//             >
//               {isLoading ? "Submitting..." : "Submit"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditComputerForm;

import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import ErrorMessage from "../Helpers/ErrorMessage";
import API from "../Context/api";
import Spinner from "../Helpers/Spinner";
import { v4 as uuidv4 } from "uuid"; // Import UUID for unique ChangeHistoryID

// EditComputerForm component for updating a computer record
const EditComputerForm = ({ setIsModalOpen, onComputerAdded, id }) => {
  // Authentication context
  const { user } = useAuth();
  const createdBy = user?.name || "";

  const computerId = id;

  // State declarations
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [technicians, setTechnicians] = useState([]);
  const initialFormData = {
    name: "",
    serialNumber: "",
    make: "",
    model: "",
    client: "",
    resourceAssigned: "",
    repairStatusType: "In Repair",
    problemDescription: "",
    repairStatusDate: new Date().toISOString(),
    companyAssetTag: "",
    repairHistory: [],
    changeHistory: [],
    repairDetails: "",
    createdBy,
    taskID: "",
    computerID: "",
    inventoryTrackingNumber: "",
    isFaulty: false,
    isRepaired: false,
    repairDetails: "",
    recommendations: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [originalFormData, setOriginalFormData] = useState(initialFormData);

  // Computer make options
  const computerMakes = [
    "Dell",
    "HP",
    "Lenovo",
    "Asus",
    "Acer",
    "Apple",
    "MSI",
  ];

  // Validate required fields
  const requiredFields = [
    "name",
    "serialNumber",
    "model",
    "make",
    "client",
    "companyAssetTag",
    "resourceAssigned",
    "createdBy",
  ];
  const isFormValid = requiredFields.every((field) => formData[field]?.trim());

  let TaskID = "";

  // Fetch technicians and computer data on mount
  useEffect(() => {
    const fetchData = async () => {
      setIsFetching(true);
      try {
        const [techniciansResponse, computerResponse] = await Promise.all([
          API.get("/users/role"),
          API.get(`/computers/${id}`),
        ]);

        setTechnicians(techniciansResponse.data);

        const item = computerResponse.data;
        const taskId = item.fields.TaskID;

        const transformed = {
          name: item.fields.Name || "",
          serialNumber: item.fields.SerialNumber || "",
          make: item.fields.Make || "",
          model: item.fields.Model || "",
          client: item.fields.Client || "",
          resourceAssigned: item.repairDetails?.ResourceAssigned || "",
          repairStatusType: item.repairDetails?.Status || "In Repair",
          problemDescription: item.repairDetails?.ProblemDescription || "",
          repairStatusDate:
            item.repairDetails?.Date || new Date().toISOString(),
          companyAssetTag: item.fields.CompanyAssetTag || "",
          repairHistory: item.repairHistory || [],
          changeHistory: item.changeHistory || [],
          createdBy: item.fields.CreatedBy || "",
          taskID: item.fields.TaskID || "",
          computerID: item.fields.ComputerID || "",
          inventoryTrackingNumber: item.fields.InventoryTrackingNumber || "",
          isFaulty: item.fields.IsFaulty || false,
          isRepaired: item.fields.IsRepaired || false,
          repairDetails: item.repairDetails?.RepairDetails || "", // flatten
          recommendations: item.repairDetails?.Recommendations || "", // flatten
        };

        setFormData(transformed);
        setOriginalFormData(transformed);

        // // Now fetch task using taskId directly
        // if (taskId) {
        //   const singleTask = await API.get(`/tasks/${taskId}`);
        //   // console.log("singleTask", singleTask.data.taskId);
        //   TaskID = singleTask.data.taskId;
        //   // set some other task-related state if needed
        // }
      } catch (error) {
        // console.error("Error fetching data:", error);
        setErrorMessage("Failed to load computer data or technicians");
        console.log(error);
      } finally {
        setIsFetching(false);
      }
    };
    fetchData();
  }, [id, createdBy]);

  // // Handle form input changes
  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prev) => {
  //     if (name.startsWith("repairDetails.")) {
  //       const field = name.split(".")[1];
  //       return {
  //         ...prev,
  //         repairDetails: {
  //           ...prev.repairDetails,
  //           [field]: value,
  //         },
  //       };
  //     }
  //     return {
  //       ...prev,
  //       [name]: type === "checkbox" ? checked : value,
  //     };
  //   });
  // };

  // Handle form input changes and track changes
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Get technician ID by name
  const getTechnicianIdByName = (name) => {
    const tech = technicians.find((t) => t.name === name);
    return tech ? tech.userId : null;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    const missingFields = requiredFields.filter(
      (field) => !formData[field]?.trim()
    );

    if (missingFields.length > 0) {
      setErrorMessage(
        `Please fill in required fields: ${missingFields.join(", ")}`
      );
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      // Track change history
      let updatedChangeHistory = [...formData.changeHistory];
      const fieldsToTrack = [
        "name",
        "serialNumber",
        "model",
        "make",
        "client",
        "resourceAssigned",
        "repairStatusType",
        "companyAssetTag",
        "problemDescription",
      ];

      fieldsToTrack.forEach((field) => {
        const oldValue = originalFormData[field] ?? "";
        const newValue = formData[field] ?? "";
        if (String(oldValue) !== String(newValue)) {
          updatedChangeHistory.push({
            Title: `${field} updated`,
            Date: new Date().toISOString(),
            ChangeHistoryID: uuidv4(),
            ComputerID: formData.computerID,
            ChangedBy: createdBy,
            Field: field,
            OldValue: oldValue,
            NewValue: newValue,
          });
        }
      });

      const originalTechId = getTechnicianIdByName(
        initialFormData?.resourceAssigned
      );
      const currentTechId = getTechnicianIdByName(formData.resourceAssigned);

      //STEP 1: Check if assigned technician changed
      if (originalFormData.resourceAssigned !== formData.resourceAssigned) {
        //Delete existing task
        if (formData.taskID) {
          await API.delete(`/tasks/${formData.taskID}`);
        }

        //Create new task
        const newTaskPayload = {
          Title: `Repair Task for ${formData.name}`,
          AssignedTo: currentTechId,
          AssignedToName: formData.resourceAssigned,
          Description: formData.problemDescription,
          Status: formData.repairStatusType,
          CreatedBy: createdBy,
          DateAssigned: new Date().toISOString(),
        };

        const taskCreateResponse = await API.post("/tasks", newTaskPayload);
        const createdTask = taskCreateResponse.data;

        // Update taskID in formData to match new one
        formData.taskID = createdTask.taskId;
      }

      // 3️⃣ Prepare data for updating computer, repair, and history
      const computerId = formData.computerID; // from SharePoint/computer record
      const repairId = formData.repairId; // make sure this is populated during fetch
      const inventoryTrackingNumber = formData.inventoryTrackingNumber; // keep existing

      const fields = {
        Title: `Asset - ${formData.name}`,
        ComputerID: computerId,
        Name: formData.name,
        Client: formData.client,
        Model: formData.model,
        SerialNumber: formData.serialNumber,
        InventoryTrackingNumber: inventoryTrackingNumber,
        Make: formData.make,
        CompanyAssetTag: formData.companyAssetTag,
        IsFaulty: formData.isFaulty ?? true,
        IsRepaired: formData.isRepaired ?? false,
        CreatedBy: formData.createdBy || createdBy,
        TaskID: formData.taskID || "", // Keep current taskID
      };

      const repairDetails = {
        Title: `Repair - ${formData.name}`,
        RepairDetails: formData.repairDetails,
        ComputerID: computerId,
        ResourceAssigned: formData.resourceAssigned,
        Status: formData.repairStatusType,
        Date: formData.repairStatusDate || new Date().toISOString(),
        Recommendations: formData.recommendations,
        CompanyAssetTag: formData.companyAssetTag,
        RepairID: repairId,
        ProblemDescription: formData.problemDescription,
      };

      const repairDetailsChanged =
        (formData.repairDetails || "") !==
        (initialFormData.repairDetails || "");

      const recommendationsChanged =
        (formData.recommendations || "") !==
        (initialFormData.recommendations || "");

      let updatedRepairHistory = [...formData.repairHistory];

      if (repairDetailsChanged || recommendationsChanged) {
        const newRepairHistoryEntry = {
          Title: `Repair Update - ${formData.name}`,
          SerialNumber: formData.serialNumber,
          Date: new Date().toISOString(),
          Description: `${formData.repairDetails} ${formData.recommendations}`,
          Status: formData.repairStatusType,
          RepairHistoryID: uuidv4(),
          ComputerID: formData.computerID,
        };

        updatedRepairHistory.push(newRepairHistoryEntry);
      }

      const submissionData = {
        fields,
        repairDetails,
        changeHistory: updatedChangeHistory,
        repairHistory: updatedRepairHistory,
      };

      // 4️⃣ Submit full computer + repair + history
      await API.put(`/computers/${id}`, submissionData);
      setFormData(initialFormData);
      setIsModalOpen(false);
      if (onComputerAdded) {
        onComputerAdded();
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to update computer";
      setErrorMessage(errorMsg);
      // console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Render UI
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
      <div className="w-full h-[450px] p-4 max-h-[80vh] max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col">
        <div className="">
          {isFetching && (
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
              <Spinner />
            </div>
          )}
          {/* Header */}
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
            Edit Asset
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>
        {/* Scrollable Form */}
        <form
          onSubmit={handleSubmit}
          className="flex-1 overflow-y-auto space-y-3"
        >
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Asset Name
              </label>
              <input
                id="name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label
                htmlFor="serialNumber"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Serial Number
              </label>
              <input
                id="serialNumber"
                type="text"
                name="serialNumber"
                value={formData.serialNumber}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label
                htmlFor="model"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Model
              </label>
              <input
                id="model"
                type="text"
                name="model"
                value={formData.model}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <div>
              <label
                htmlFor="make"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Make
              </label>
              <select
                id="make"
                name="make"
                value={formData.make}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">Select Make</option>
                {computerMakes.map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="client"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Client
              </label>
              <input
                id="client"
                type="text"
                name="client"
                value={formData.client}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label
                htmlFor="resourceAssigned"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Assigned Resource
              </label>
              <select
                id="resourceAssigned"
                name="resourceAssigned"
                value={formData.resourceAssigned}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">Select Technician</option>
                {technicians.map((technician) => (
                  <option key={technician.id} value={technician.name}>
                    {technician.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="repairStatusType"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Repair Status
              </label>
              <select
                id="repairStatusType"
                name="repairStatusType"
                value={formData.repairStatusType}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="In Repair">In Repair</option>
                <option value="Completed">Completed</option>
              </select>
            </div>
          </div>

          <div>
            <label
              htmlFor="companyAssetTag"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Company Asset Tag
            </label>
            <input
              id="companyAssetTag"
              type="text"
              name="companyAssetTag"
              value={formData.companyAssetTag}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          <div>
            <label
              htmlFor="problemDescription"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Problem Description
            </label>
            <textarea
              id="problemDescription"
              name="problemDescription"
              value={formData.problemDescription}
              onChange={handleChange}
              rows={4}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          {formData.repairDetails.trim() !== "" &&
            formData.recommendations?.trim() !== "" && (
              <div>
                <div>
                  <label
                    htmlFor="repairDetails"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Repair Details
                  </label>
                  <textarea
                    id="repairDetails"
                    name="repairDetails"
                    value={formData.repairDetails}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    rows={4}
                  />
                </div>

                <div>
                  <label
                    htmlFor="recommendations"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Recommendations
                  </label>
                  <textarea
                    id="recommendations"
                    name="recommendations"
                    value={formData.recommendations}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    rows={4}
                  />
                </div>
              </div>
            )}
        </form>

        {/* Action Buttons */}
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-semibold transition duration-200 w-full sm:w-auto"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={!isFormValid || isLoading}
            className={`px-4 py-2 rounded-md text-sm font-semibold w-full sm:w-auto transition duration-200 ${
              !isFormValid || isLoading
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-800"
            }`}
          >
            {isLoading ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditComputerForm;
